import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ElfsightService {
  private _elfsightAppId: string = "1e021cc2-b29b-4fcc-af0f-22876fe995f8";

  constructor() {}

  public addElfsightWidget(): void {
    const existingWidget: NodeListOf<Element> = document.querySelectorAll(
      `.elfsight-app-${this._elfsightAppId}`,
    );
    if (existingWidget) {
      existingWidget.forEach((elfsight) => elfsight.remove());
    }

    const eaapsPortals: NodeListOf<Element> = document.querySelectorAll("#__EAAPS_PORTAL");
    eaapsPortals.forEach((portal) => portal.remove());

    setTimeout(() => {
      if (!document.querySelector(`.elfsight-app-${this._elfsightAppId}`)) {
        const widgetDiv: HTMLDivElement = document.createElement("div");
        widgetDiv.className = `elfsight-app-${this._elfsightAppId}`;
        widgetDiv.setAttribute("data-elfsight-app-lazy", "");
        document.body.appendChild(widgetDiv);
      }
    }, 2100);
  }
}
